import { render } from "./PaymentToken.vue?vue&type=template&id=30391636&scoped=true"
import script from "./PaymentToken.vue?vue&type=script&lang=js"
export * from "./PaymentToken.vue?vue&type=script&lang=js"

import "./PaymentToken.vue?vue&type=style&index=0&id=30391636&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-30391636"

export default script